<style>
/* table .dropdown-menu {
    position: fixed !important;
    top: 50% !important;
    left: 92% !important;
    transform: translate(-92%, -50%) !important;
} */

#nonberusahaBendahara_info,
#nonberusahaBendahara_paginate,
#nonberusahaBendahara_filter {
  display: none;
}
</style>
<template>
  <div>
    <div v-if="show" :show="show" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>

    </div>
    <div v-if="!show">
      <div class="d-flex justify-content-between">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input v-model="search.value" type="text" class="form-control" id="search">
            </div>
            <div>
              <select v-model="search.field" class="form-control">
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="instansi_pemohon">Instansi Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option value="nama_perairan">Nama Perairan</option>
                <option value="provinsi">Provinsi</option>
                <!-- <option value="status_verdok">Status Verdok</option> -->
                <option value="status_permohonan">Status Permohonan</option>
                <option value="keterangan_status">Keterangan Status</option>
                <option value="tanggal_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_lolos_verifikasi_administrasi">Tgl. Verdok</option>
                <option value="pic_name">PIC Pentek</option>
              </select>
            </div>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control">
                <option value="createdAt">Tgl. Dibuat</option>
                <option value="tanggal_permohonan">Tgl. Permohonan</option>
                <option value="tanggal_lolos_verifikasi_administrasi">Tgl. Verdok</option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table id="nonberusahaBendahara" class="table" style="width: 100%">
          <thead>
            <tr>
              <th class="all">No</th>
              <th class="all">Nomor Pemohon</th>
              <th class="all">Instansi Pemohon</th>
              <th class="all">Jenis Kegiatan</th>
              <th class="all">Nama Perairan</th>
              <th class="all">Provinsi</th>
              <!-- <th>Status Verdok</th> -->
              <th>Status Permohonan</th>
              <th>Keterangan Status</th>
              <th class="all">Tanggal Permohonan</th>
              <th>Tanggal Berlaku Tagihan</th>
              <th>Status Tagihan</th>
              <th>PIC Pentek</th>
              <th style="text-align: center">Unduh File</th>
              <!-- <th>File Surat Tugas</th>
                        <th>File Undangan</th>
                        <th>File BA</th>
                        <th>File Memo</th> -->
              <th class="all">Aksi</th>
            </tr>
            <!-- <tr>
                        <th>Bukti Pembayaran</th>
                        <th>Surat Tugas</th>
                        <th>Undangan</th>
                        <th>BA</th>
                        <th>Memo</th>
                        <th>Persetujuan</th>
                    </tr> -->
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataPermohonan" :key="data.id">
              <td class="sticky-col second-col">
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  index + pagination.firstInPage }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">{{ index + pagination.firstInPage }}</div>
                </span>
              </td>
              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <span class="badge rounded-pill bg-success" style="font-size: 10px; font-weight: normal"
                    v-if="data.nomor_permohonan != null">{{ data.nomor_permohonan }}</span>
                  <span class="badge rounded-pill bg-danger" style="
                    font-size: 10px;
                    font-weight: normal;
                    background-color: #ff6e7c !important;
                  " v-else>Belum Ada</span>
                </span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    <span class="badge rounded-pill bg-success" style="font-size: 10px; font-weight: normal"
                      v-if="data.nomor_permohonan != null">{{ data.nomor_permohonan }}</span>
                    <span class="badge rounded-pill bg-danger" style="
                      font-size: 10px;
                      font-weight: normal;
                      background-color: #ff6e7c !important;
                    " v-else>Belum Ada</span>
                  </div>
                </span>
              </td>
              <td class="sticky-col second-col">
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ data.instansi_pemohon
                  }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ data.instansi_pemohon }}
                  </div>
                </span>
              </td>

              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ data.jenis_kegiatan
                  }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ data.jenis_kegiatan }}
                  </div>
                </span>
              </td>
              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ data.nama_perairan
                  }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ data.nama_perairan }}
                  </div>
                </span>
              </td>

              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ data.provinsi }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ data.provinsi }}
                  </div>
                </span>
              </td>
              <!-- <td>
              <span
                v-if="data.status_verdok == 'Perbaikan Persyaratan'"
                style="color: red"
                >{{ data.status_verdok }}</span
              >
              <span v-else>
                <div
                  :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]"
                >
                  {{ data.status_verdok }}
                </div>
              </span>
            </td> -->
              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ data.status_permohonan
                  }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ data.status_permohonan }}
                  </div>
                </span>
              </td>
              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ data.keterangan_status
                  }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ data.keterangan_status }}
                  </div>
                </span>
              </td>
              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  format_date(data.tanggal_pada_permohonan) }}</span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ format_date(data.tanggal_pada_permohonan) }}
                  </div>
                </span>
              </td>

              <!-- <td>
                            <span v-if="data.file_undangan != null">
                                <a :href="data.file_undangan" target="_blank"
                                    ><i class="fa fa-download" aria-hidden="true"
                                /> Unduh</a>
                            </span>
                        </td> -->
              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <span v-if="data.status_tagihan_iii != null">
                    {{ format_date(data.tanggal_berlaku_hingga_tagihan_iii) }}
                  </span>
                  <span v-else-if="
                    data.status_tagihan_ii != null &&
                    data.status_tagihan_i != null
                  ">
                    {{ format_date(data.tanggal_berlaku_hingga_tagihan_ii) }}
                  </span>
                  <span v-else>
                    {{ format_date(data.tanggal_berlaku_hingga_tagihan_i) }}
                  </span>
                </span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    <span v-if="data.status_tagihan_iii != null">
                      {{ format_date(data.tanggal_berlaku_hingga_tagihan_iii) }}
                    </span>
                    <span v-else-if="
                      data.status_tagihan_ii != null &&
                      data.status_tagihan_i != null
                    ">
                      {{ format_date(data.tanggal_berlaku_hingga_tagihan_ii) }}
                    </span>
                    <span v-else>
                      {{ format_date(data.tanggal_berlaku_hingga_tagihan_i) }}
                    </span>
                  </div>
                </span>
                <!-- <span v-if="data.status_tagihan_iii != null">
                            {{format_date(data.tanggal_berlaku_hingga_tagihan_iii)}}
                            </span>
                            <span v-else-if="data.status_tagihan_ii != null && data.status_tagihan_i != null">
                            {{format_date(data.tanggal_berlaku_hingga_tagihan_ii)}}
                            </span>
                            <span v-else>
                            {{format_date(data.tanggal_berlaku_hingga_tagihan_i)}}
                            </span> -->
              </td>
              <td>
                <span v-if="data.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <span v-if="data.status_tagihan_iii != null">
                    {{ data.status_tagihan_iii }}
                  </span>
                  <span v-else-if="
                    data.status_tagihan_ii != null &&
                    data.status_tagihan_i != null
                  ">
                    {{ data.status_tagihan_ii }}
                  </span>
                  <span v-else>
                    {{ data.status_tagihan_i }}
                  </span>
                </span>
                <span v-else>
                  <div :style="[
                    data.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    <span v-if="data.status_tagihan_iii != null">
                      {{ data.status_tagihan_iii }}
                    </span>
                    <span v-else-if="
                      data.status_tagihan_ii != null &&
                      data.status_tagihan_i != null
                    ">
                      {{ data.status_tagihan_ii }}
                    </span>
                    <span v-else>
                      {{ data.status_tagihan_i }}
                    </span>
                  </div>
                </span>
              </td>
              <td>
                {{ data.pic_name }}
              </td>
              <td>
                <FileDownloadNonberusaha :data="data" />
              </td>
              <td>
                <div class="d-flex align-items-center gap-1 flex-wrap">
                  <!-- Tombol Detail -->
                  <b-button size="sm" variant="info" class="text-white" v-b-tooltip.hover title="Detail"
                    @click="$router.push('/app/nonberusaha/detail-perizinan/' + data.id)">
                    <i class="fa fa-eye mr-1"></i> Detail
                  </b-button>

                  <template v-if="data.file_ba_vertek != null && data.tipe_pemohon == 'Swasta'">
                    <!-- Tombol Buat Tagihan -->
                    <b-button v-if="!data.bukti_pembayaran && data.status_tagihan_iii !== 'Tidak Dibayarkan'" size="sm"
                      variant="primary" @click="verifPembayaran(data.id)">
                      <i class="fa fa-file-text-o mr-1"></i> Buat Tagihan
                    </b-button>

                    <!-- Tombol Cek Status Pembayaran -->
                    <b-button v-if="canCheckStatusBayar(data)" size="sm" variant="secondary"
                      @click="checkStatusBayar(data)">
                      <i class="fa fa-search mr-1"></i> Cek Status Pembayaran
                    </b-button>
                  </template>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ?
              pagination.limit * pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="['page-link', { 'active': i === `${pagination.currentPage}` }]" href="#"
                @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import * as xlsx from "xlsx";
import FileDownloadNonberusaha from "../../Components/FileDownloadNonberusaha.vue";
export default {
  components: { FileDownloadNonberusaha },
  data() {
    return {
      fields: [
        "no",
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        { key: "status_verdok", label: "Status", sortable: true },
        { key: "tanggal_pada_permohonan", label: "Tanggal Permohonan" },
        { key: "tanggal_berlaku", label: "Tanggal Berlaku Tagihan" },
        { key: "status_tagihan", label: "Status Tagihan" },
        "Aksi",
      ],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { id: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },

      // currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      dataPermohonan: [],
      selectedFile: null,

      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: "nomor_permohonan",
        value: "",
      },
      sort: {
        field: "tanggal_permohonan",
        direction: "DESC",
      },
      debounceTerm: null,
      show: false
    };
  },
  props: {
    itemsWithNumber: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rows: Number,
    tipe: String,
    totalRows: Number,
    currentPage: Number,
    user: {
      // type: Array,
      default: () => {
        return [];
      },
    },
    baseapi: String,
  },
  mounted() {
    this.getdata();
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata();
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata();
      },
      deep: true,
    },
  },
  methods: {
    onFiltered(data) {
      this.$emit("onFiltered", data);
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    pilihModal() {
      this.$emit("pilihModal");
    },
    getDetailPerDokumen(data) {
      this.$emit("getDetailPerDokumen", data);
    },
    deleteDokumen(data) {
      this.$emit("deleteDokumen", data);
    },
    verifPembayaran(data) {
      this.$emit("verifPembayaran", data);
    },

    getdata() {
      $("#nonberusahaBendahara").DataTable().destroy();
      this.loaddata();
    },

    loaddata() {
      this.show = true
      this.dataPermohonan = []
      // const api = `api/permohonan_nonberusaha/dataTable?page=${this.pagination.currentPage}&filter=tipe_pemohon,=,${this.tipe};${this.search.field},like,${this.search.value}`
      const api = `api/permohonan_nonberusaha/dataTable` +
        `?page=${this.pagination.currentPage}` +
        `&filter=tipe_pemohon,=,${this.tipe}${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_permohonan' || this.search.field === 'tanggal_lolos_verifikasi_administrasi' ? '>=' : 'like'},${this.search.value}` : ''}` +
        `&sort=${this.sort.field},${this.sort.direction}`
      // "api/permohonan_nonberusaha?filter=tipe_pemohon,=,"+this.tipe,
      axios
        .get(
          this.baseapi + api,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data;
          for (let index = 0; index < this.dataPermohonan.length; index++) {
            Vue.set(this.dataPermohonan[index], "selectedFile", null);
          }
          this.initDatatable();
        })
        .catch((error) => {
          console.log(error);
          return error;
        }).finally(() => {
          this.show = false
        });
    },

    //Emit Check Status Bayar
    checkStatusBayar(data) {
      this.$emit("checkStatusBayar", data);
    },

    getBillingTerakhir(row) {
      if (row.kode_billing_tagihan_iii) {
        return {
          kode: row.kode_billing_tagihan_iii,
          status: row.status_tagihan_iii
        }
      }

      if (row.kode_billing_tagihan_ii) {
        return {
          kode: row.kode_billing_tagihan_ii,
          status: row.status_tagihan_ii
        }
      }

      if (row.kode_billing_tagihan_i) {
        return {
          kode: row.kode_billing_tagihan_i,
          status: row.status_tagihan_i
        }
      }

      return null
    },

    canCheckStatusBayar(row) {
      const billing = this.getBillingTerakhir(row)

      if (!billing) return false

      const isBelumBayar = billing.status !== 'Sudah Dibayar'
      const isBelumSelesai = row.status_permohonan !== 'Selesai'

      return isBelumBayar && isBelumSelesai
    },

    setPagination() {
      this.$router.replace({
        path: this.$route.path,
        query: { page: this.pagination.currentPage },
      }).catch((err) => { })
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment("DD MMMM YYYY");

        var t = $("#nonberusahaBendahara").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // stateSave: true,
          // order: [[8, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 3,
            right: 1,
          },
          scrollX: true,
          dom: "Bfrtip",
          // fnRowCallback: function (
          //   nRow,
          //   aData,
          //   iDisplayIndex,
          //   iDisplayIndexFull
          // ) {
          //   //debugger;
          //   var index = iDisplayIndexFull + 1;
          //   $("td:first", nRow).html(index);
          //   return nRow;
          // },
          columnDefs: [
            // { type: 'date-dd-mmm-yyyy', targets: 8 },
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == "export" ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            // {
            //   extend: "excelHtml5",
            //   title: "DATA PEMOHON",
            //   text: '<i class="fa fa-file-text-o"></i> Excel',
            //   className: "btn btn-success",
            //   exportOptions: {
            //     columns: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            //     orthogonal: "export",
            //     // format: {
            //     //     header: function ( data, columnIdx ) {
            //     //         if(columnIdx==7 || columnIdx==8 || columnIdx==9){
            //     //         return 'Aktivitas ' + data;
            //     //         }
            //     //         else if(columnIdx==10 || columnIdx==11){
            //     //           return 'Verifikasi Dokumentatif ' + data;
            //     //         }
            //     //         else if(columnIdx==12 || columnIdx==13){
            //     //           return 'Verifikasi Lapangan ' + data;
            //     //         }
            //     //         else if(columnIdx==14 || columnIdx==15){
            //     //           return 'File BA ' + data;
            //     //         }
            //     //         else if(columnIdx==16 || columnIdx==17 || columnIdx==18){
            //     //           return 'Predikat ' + data;
            //     //         }
            //     //         else{
            //     //           return data;
            //     //         }
            //     //     },
            //     //     body: function(data, row, column, node) {
            //     //         data = $('<p>' + data + '</p>').text();
            //     //         return data.replace(',', '.');
            //     //     },
            //     // }
            //   },
            //   filename: function () {
            //     var today = new Date();
            //     // var n = d.getTime();
            //     var date =
            //       today.getFullYear() +
            //       "-" +
            //       (today.getMonth() + 1) +
            //       "-" +
            //       today.getDate();

            //     return "Data Pemohon " + date;
            //   },
            // },
          ],
        });
        // t.on("order.dt search.dt", function () {
        //   t.column(0, { search: "applied", order: "applied" })
        //     .nodes()
        //     .each(function (cell, i) {
        //       cell.innerHTML = i + 1;
        //     });
        // }).draw();
      }, 300);
    },

    exportData() {
      this.$loading(true)
      const api = `api/permohonan_nonberusaha` +
        `?sort=${this.sort.field},${this.sort.direction}` +
        `&filter=tipe_pemohon,=,${this.tipe}${this.search.value !== '' ? `;${this.search.field},${this.search.field === 'tanggal_proses' || this.search.field === 'tanggal_pada_permohonan' ? '>=' : 'like'},${this.search.value}` : ''}`
      axios.get(this.baseapi + api, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then((res) => {
        const worksheetData = [
          ['Data Pemohon'],
          ['No', 'Nomor Pemohon', 'Instansi Pemohon', 'Jenis Kegiatan', 'Nama Perairan', 'Provinsi', 'Status Verdok', 'Status Permohonan', 'Tgl. Permohonan', 'Tgl. Verdok', 'PIC Pentek']
        ]
        const merge = [{ s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 }, }]
        res.data.data.map((d, i) => {
          worksheetData.push([
            i + 1,
            d.nomor_permohonan,
            d.instansi_pemohon,
            d.jenis_kegiatan,
            d.nama_perairan,
            d.provinsi,
            d.status_verdok,
            d.status_permohonan,
            d.tanggal_permohonan,
            d.tanggal_lolos_verifikasi_administrasi,
            d.pic_name,
          ])
        })

        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData);
        worksheet["!merges"] = merge;
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const d = new Date();
        xlsx.writeFile(workbook, `Data Pemohon ${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.xlsx`);
      }).catch((err) => {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      }).finally(() => {
        this.$loading(false)
      })
    },
  },
};
</script>